import { supportedLanguagesObject } from "./supported"
import type { Language } from "."

export const isSupportedLanguage = (
  locale: string,
): locale is Language.Locale => {
  return Boolean(supportedLanguagesObject[locale as Language.Locale])
}
